import { ContainerPage } from './styles'
import { HomeOutlined, SupervisorAccount, PersonAdd } from '@material-ui/icons'
import CampaignIcon from '@material-ui/icons/Mail';
import { Title } from '../../ElementsUI/Title'
import MenuSide from '../../navigation/Menu'
import NavBarComponent from '../../navigation/NavBar'
import webConfig from '../../../webconfig.json'
import LogoSistema from '../../../assets/img/logo-sistema.svg'
import LogoTce from '../../../assets/img/logo-tcego.svg'
import { useAuth } from 'react-oidc-context'
import { useEffect, useState } from 'react'

export default function Container(props) {
    const auth = useAuth()
    const [showActions, setShowActions] = useState(false)
    const [subMenus, setSubMenus] = useState([])

    const carregaMenu = () => {
        if (auth.isAuthenticated) {
            setSubMenus([
                {
                    descricao: "Início",
                    rota: "/Dashboard",
                    icone: <HomeOutlined />,
                    color: '#64b5f6',
                    subMenus: []
                }
            ])

            if (auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-TCE-COM') !== undefined) {
                setSubMenus(oldArray => [
                    ...oldArray,
                    {
                        descricao: "Comunicações",
                        rota: "/AcompanhamentoComunicacoes",
                        icone: <CampaignIcon />,
                        color: 'var(--ui-color-06)',
                        subMenus: []
                    }
                ]);
            }

            if (auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GAC') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-JRSD-OPA') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-JRSD-OPL') !== undefined) {
                setSubMenus(oldArray => [
                    ...oldArray,
                    {
                        descricao: "Minhas Comunicações",
                        rota: "/MinhasComunicacoes",
                        icone: <CampaignIcon />,
                        color: 'var(--ui-color-06)',
                        subMenus: []
                    }
                ]);
            }

            if (auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-TCE-TRI') !== undefined) {
                setSubMenus(oldArray => [
                    ...oldArray,
                    {
                        descricao: "Controle de Acesso TCE-GO",
                        rota: "/Triagem",
                        icone: <SupervisorAccount />,
                        color: '#1d52cf',
                        subMenus: []
                    }
                ]);
            }

            if (auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GAC') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') !== undefined) {

                setSubMenus(oldArray => [
                    ...oldArray,
                    {
                        descricao: "Gerenciar Perfis",
                        rota: "/GerenciaPerfis",
                        icone: <PersonAdd />,
                        color: '#28a11b',
                        subMenus: []
                    }
                ]);
            }

            if (auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') !== undefined) {
                setSubMenus(oldArray => [
                    ...oldArray,
                    {
                        descricao: "Acesso do Gestor Jurisdicionado",
                        rota: "/Solicitacao",
                        icone: <PersonAdd />,
                        color: '#2c3782',
                        subMenus: []
                    }
                ]);
            }
        }
    }

    useEffect(() => {
        if (auth.isAuthenticated) {
            //Salva os dados do usuário no localStorage
            localStorage.setItem(`@${process.env.REACT_APP_NOME_SISTEMA}-data`, JSON.stringify({
                id: auth.user?.profile.preferred_username,
                nome: auth.user?.profile.name,
                email: auth.user?.profile.email,
                setor: '',
                usuario: auth.user?.profile.preferred_username
            }))
        }

        carregaMenu()
        setShowActions(auth.isAuthenticated);
    }, auth)

    return (
        <>
            <ContainerPage id="ContainerPage">
                <NavBarComponent
                    logoOuvidoria={LogoSistema}
                    logoSistema={LogoSistema}
                    nomeSistema={webConfig.nomeSistema}
                    ImgLogoTCEGO={LogoTce}
                    dataMenus={subMenus}
                    showActions={showActions}
                    showSearch={false}
                />
                <ContainerPage.Content id="ContainerPage_Content">
                    <ContainerPage.Menu id="ContainerPage_Menu">
                        <MenuSide subMenus={subMenus} />
                    </ContainerPage.Menu>
                    <ContainerPage.ContentPage id="ContainerPage_ContentPage">
                        <Title>{props.title}</Title>
                        <Title.Description>{props.description}</Title.Description>
                        {props.children}
                    </ContainerPage.ContentPage>
                </ContainerPage.Content>
            </ContainerPage>
        </>
    )
}